import { lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import { Header } from '@/components/layout/Header';
import { Footer } from '@/components/layout/Footer';
import { LandingPage } from '@/features/landing/LandingPage';

// The app shell is lazy so its bundle never loads for a landing-page visitor.
// It will get much heavier once the Figma screens land; keeping the split here
// from the start means that growth stays off the marketing critical path.
const AppShell = lazy(() =>
  import('@/app/AppShell').then((m) => ({ default: m.AppShell })),
);

function PublicSite() {
  return (
    <>
      <a className="skip-link" href="#main">
        Skip to content
      </a>
      <Header />
      <main id="main">
        <LandingPage />
      </main>
      <Footer />
    </>
  );
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<PublicSite />} />
      <Route
        path="/app/*"
        element={
          <Suspense fallback={<div style={{ padding: '4rem', textAlign: 'center' }}>Loading…</div>}>
            <AppShell />
          </Suspense>
        }
      />
      {/* Amplify already rewrites unknown paths to index.html (404-200), so
          an unmatched route lands here rather than on a server 404. Show the
          landing page rather than a dead end. */}
      <Route path="*" element={<PublicSite />} />
    </Routes>
  );
}
